import useIsMobile from "@/hooks/useIsMobile";
import PageLayout from "@/screens/Layout/PageLayout";
import SearchPage from "@/screens/Search";

const Index = ({
  searchResultData = null,
  query = "",
}) => {
  const isMobileDevice = useIsMobile();
  return (
    <PageLayout isMobileDevice={isMobileDevice}>
      <SearchPage
        searchResultData={searchResultData}
        query={query}
        isMobileDevice={isMobileDevice}
      />
    </PageLayout>
  );
};

export const getServerSideProps = async (ctx) => {
  const { logger } = await import("@/utils/logging/log-util");
  const query = "";
  try {
    const query = ctx?.params?.query ?? "";
    const { getListByCategoryId, getCategoryList } = await import(
      "@/handlers/webstory"
    );
    const { getRedisApiKey, fetchRedisWrapper } = await import(
      "@/handlers/redisKey"
    );
    const { setPageTTL } = await import("@/utils/setPageTTL");
    //* get page from query param and subtract 1 from it , also error handle if not a number
    let page = ctx?.query?.page;
    if (isNaN(page)) {
      page = 0;
    }
    page = page ? parseInt(page) - 1 : 0;

    //* get redis api key for each api
    let webstoryListRedisKey = getRedisApiKey({
      redisPrefix: "PREFIX_REDIS_ROS",
      params: { api: "webstorylist", id: 300629, page: page, display: 18 },
    });
    let webstoryCategoryListRedisKey = getRedisApiKey({
      redisPrefix: "PREFIX_REDIS_ROS",
      params: { api: "webstorycategorylist" },
    });

    let [webstoryListData] = await Promise.all([
      fetchRedisWrapper(webstoryListRedisKey, () =>
        getListByCategoryId({ id: 30062, page: page, display: 18 })
      ),
      fetchRedisWrapper(webstoryCategoryListRedisKey, () => getCategoryList()),
    ]);

    let headerCache = webstoryListData?.cache;

    setPageTTL(ctx, headerCache?.akamai_ttl);

    return {
      props: {
        searchResultData: null,
        query,
      },
    };
  } catch (error) {
    logger.error(error);
    return {
      props: {
        searchResultData: null,
        query,
      },
    };
  }
};

export default Index;
